import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';

import { LanguageCode } from '../../../../../../../../shared/modules/language/services/language.service';

@Component({
  selector: 'sh-main-nav-language-flag',
  imports: [TranslocoPipe],
  templateUrl: './main-nav-language-flag.component.html',
  styleUrl: './main-nav-language-flag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainNavLanguageFlagComponent {
  @Input() code: LanguageCode | undefined;
}
